import _ from 'lodash';

export default class History {
  constructor(data) {
    this.cartOrder = _.get(data, 'cartOrder', '');
    this.shop = _.get(data, 'shop', '');
    this.user = _.get(data, 'user', '');
    this.time = _.get(data, 'time', '');
    this.priceHt = _.get(data, 'priceHt', '');
    this.supplier = _.get(data, 'supplier', '');
    this.status = _.get(data, 'status', []);
    this.id = _.get(data, 'id', null);
  }
}
